<template>
    <div class="wechat-container">
        <div class="wechat-wrapper">
            <div class="wechat-top">
                <div class="wechat-title" v-if="type=='memberWechatList'">聊天记录</div>
                <div class="wechat-title" v-else>{{friends.wechat_nickname}}</div>
                <el-form :inline="true" :model="ruleForm">
                    <el-form-item>
                        <el-date-picker class="date_range mr8" v-model="ruleForm.times" type="daterange"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="请输入内容" clearable v-model="ruleForm.keywords"
                            class="input-place mr8"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="ruleForm.types" collapse-tags multiple placeholder="请选择类型" filterable
                            clearable class="input-place mr8">
                            <el-option v-for="(item, index) in typeList" :key="index" :label="item.title"
                                :value="item.id + ''"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" class="mr8" native-type="submit" @click="handleSearch">搜索</el-button>
                    <!-- <el-button type="danger" class="mr8" @click="download">导出聊天记录</el-button> -->
                </el-form>
            </div>
            <div class="wechat-contant" ref="mianscroll">
                <div class="nextPage" @click="nextPage" v-if="getMemberWechatLog.length>0" v-show="isShow">查看更多数据</div>
                <template v-if="getMemberWechatLog.length>0">
                    <div v-for="(i,index) in getMemberWechatLog" :key="index">
                        <template v-if="i.has_head=='true'">
                            <div v-if="i.mine==''">
                                <div v-if="i.type==-1" class="tipsmsg">未知类型-暂无处理</div>
                                <div v-else-if="i.type==-2" class="tipsmsg">{{i.text}}</div>
                                <div v-else class="tipsmsg">{{i.text}}</div>
                            </div>
                            <div v-else class="time-line">{{i.text}}</div>
                        </template>
                        <template v-if="i.has_head=='false'">
                            <template v-if="i.mine=='true'">
                                <div v-if="i.type==15" class="tipsmsg">{{i.text}}</div>
                                <div v-else class="message-item right-message-item">
                                    <div class="my-avatar">
                                        <!-- 视频语音 s -->
                                        <span v-if="i.type==7||i.type==6" class="my-avatar-range"><img
                                                class="my-avatar-range"
                                                src="http://yunke-pcfile.oss-cn-beijing.aliyuncs.com/wechat_img/default_head.png"></span>
                                        <span v-else class="my-avatar-range"><img class="my-avatar-range"
                                                :src="i.avatar"></span>
                                    </div>
                                    <div class="my-content">
                                        <div class="title">{{i.nickname}}{{i.timestamp}}</div>
                                        <div class="message-content">
                                            <div v-if="i.type==2" class="message-info-pic"><el-image class="message-pic"
                                                    :preview-src-list="[i.new_file]" :src="i.new_file"></el-image></div>
                                            <!-- 视频语音 s -->
                                            <div v-else-if="i.type==7||i.type==6">
                                                <div class="message-info">
                                                    <audio controls ref="audio" class="aud">
                                                        <source :src="i.new_file" />
                                                        您的浏览器不支持 audio 标签。
                                                    </audio>
                                                </div>
                                            </div>
                                            <!-- 地图 -->
                                            <div v-else-if="i.type==14" class="message-info">
                                                {{i.text}}
                                                <baidu-map class="map"
                                                    :center="{lng: i.file.split(',')[1], lat: i.file.split(',')[0]}"
                                                    :zoom="14" :scroll-wheel-zoom="true"
                                                    ak="63QVqEvyj25jES6qQdohDQiNomHEq7Iv">
                                                    <bm-marker
                                                        :position="{ lng: i.file.split(',')[1], lat: i.file.split(',')[0] }"
                                                        :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                                                        <bm-label :content="i.text"
                                                            :labelStyle="{color: '',borderColor:'#fff', fontSize : '12px'}"
                                                            :offset="{width: -35, height: 30}" />
                                                    </bm-marker>
                                                </baidu-map>
                                            </div>
                                            <!-- 语音 -->
                                            <div v-else-if="i.type==3" class="message-info">
                                                <audio controls ref="audio" class="aud">
                                                    <source :src="i.new_file" />
                                                    您的浏览器不支持 audio 标签。
                                                </audio>
                                            </div>
                                            <!-- 视频 -->
                                            <div v-else-if="i.type==4" class="message-info">
                                                <video id="media" class="media" width="250" controls
                                                    :src="i.new_file"></video>
                                            </div>
                                            <!-- 聊天GIF动图 -->
                                            <div v-else-if="i.type==8" class="message-info">
                                                <img class="my-avatar-range" :src="i.new_file">
                                            </div>
                                            <!-- 下载 -->
                                            <div v-else-if="i.type==9" class="message-info">
                                                <div class="download-box">
                                                    <div class="download-name">{{i.text}}</div>
                                                    <div class="download-icon">
                                                        <i class="el-icon-folder-opened"></i>
                                                    </div>
                                                    <div class="download-icon">
                                                        <a :href="i.new_file"> <i class="el-icon-download"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 点击外链 -->
                                            <div v-else-if="i.type==10" class="message-info">
                                                <div class="link-box">
                                                    <a class="link-text" :href="i.file">{{i.text}}</a>
                                                    <div class="link-img"><img src="@/assets/img/link.png" /></div>
                                                </div>
                                            </div>
                                            <div v-else-if="i.type==13" class="message-info">
                                                <div class="chat-card">
                                                    <div class="chat-card-list">
                                                        <div class="chat-img"><img class="my-avatar-range"
                                                                :src="i.new_file"></div>
                                                        <div class="chat-text">{{i.text}}</div>
                                                    </div>
                                                    <div class="card">个人名片</div>
                                                </div>
                                            </div>
                                            <div v-else-if="i.type==18" class="message-info">
                                                <div class="miniprogram-header">{{i.text}}</div>
                                                <div class="miniprogram-img-thumb"><img class="my-avatar-range"
                                                        :src="i.new_file"></div>
                                                <div class="miniprogram-footer">
                                                    <div class="miniprogram-icon"><img src="@/assets/img/link.png" />
                                                    </div>
                                                    <div>小程序</div>
                                                </div>
                                            </div>
                                            <div v-else class="message-info" v-html="i.text.replace(/\n/gm, '<br>')">
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="i.mine=='false'">
                                <!-- 以上是打招呼的内容 -->
                                <div v-if="i.type==15" class="tipsmsg">{{i.text}}</div>
                                <div v-else class=" message-item left-message-item">
                                    <div class="my-avatar">
                                        <!-- 视频语音 s -->
                                        <span v-if="i.type==7||i.type==6" class="my-avatar-range"><img
                                                class="my-avatar-range"
                                                src="http://yunke-pcfile.oss-cn-beijing.aliyuncs.com/wechat_img/default_head.png"></span>
                                        <span v-else class="my-avatar-range"><img class="my-avatar-range"
                                                :src="i.avatar"></span>
                                    </div>
                                    <div class="my-content">
                                        <div class="title">{{i.nickname}}{{i.timestamp}}</div>
                                        <div class="message-content">
                                            <div v-if="i.type==2" class="message-info-pic"><el-image class="message-pic"
                                                    :preview-src-list="[i.new_file]" :src="i.new_file"></el-image></div>
                                            <!-- 视频语音 s -->
                                            <div v-else-if="i.type==7||i.type==6">
                                                <div class="message-info">
                                                    <audio controls ref="audio" class="aud">
                                                        <source :src="i.new_file" />
                                                        您的浏览器不支持 audio 标签。
                                                    </audio>
                                                </div>
                                            </div>
                                            <!-- 地图 -->
                                            <div v-else-if="i.type==14" class="message-info">
                                                <div class="map-title">{{i.text}}</div>
                                                <baidu-map class="map"
                                                    :center="{lng: i.file.split(',')[1], lat: i.file.split(',')[0]}"
                                                    :zoom="14" :scroll-wheel-zoom="true"
                                                    ak="63QVqEvyj25jES6qQdohDQiNomHEq7Iv">
                                                    <bm-marker
                                                        :position="{ lng: i.file.split(',')[1], lat: i.file.split(',')[0] }"
                                                        :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
                                                        <bm-label :content="i.text"
                                                            :labelStyle="{color: '',borderColor:'#fff', fontSize : '12px'}"
                                                            :offset="{width: -35, height: 30}" />
                                                    </bm-marker>
                                                </baidu-map>
                                            </div>
                                            <!-- 语音 -->
                                            <div v-else-if="i.type==3" class="message-info">
                                                <audio controls ref="audio" class="aud">
                                                    <source :src="i.new_file" />
                                                    您的浏览器不支持 audio 标签。
                                                </audio>
                                            </div>
                                            <!-- 视频 -->
                                            <div v-else-if="i.type==4" class="message-info">
                                                <video id="media" class="media" width="250" controls
                                                    :src="i.new_file"></video>
                                            </div>
                                            <!-- 聊天GIF动图 -->
                                            <div v-else-if="i.type==8" class="message-info">
                                                <img class="my-avatar-range" :src="i.new_file">
                                            </div>
                                            <!-- 下载 -->
                                            <div v-else-if="i.type==9" class="message-info">
                                                <div class="download-box">
                                                    <div class="download-name">{{i.text}}</div>
                                                    <div class="download-icon">
                                                        <i class="el-icon-folder-opened"></i>
                                                    </div>
                                                    <div class="download-icon">
                                                        <a :href="i.new_file"> <i class="el-icon-download"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 点击外链 -->
                                            <div v-else-if="i.type==10" class="message-info">
                                                <div class="link-box">
                                                    <a class="link-text" :href="i.new_file">{{i.text}}</a>
                                                    <div class="link-img"><img src="@/assets/img/down.png" /></div>
                                                </div>
                                            </div>
                                            <div v-else-if="i.type==13" class="message-info">
                                                <div class="chat-card">
                                                    <div class="chat-card-list">
                                                        <div class="chat-img"><img class="my-avatar-range"
                                                                :src="i.new_file"></div>
                                                        <div class="chat-text">{{i.text}}</div>
                                                    </div>
                                                    <div class="card">个人名片</div>
                                                </div>
                                            </div>
                                            <div v-else-if="i.type==18" class="message-info">
                                                <div class="miniprogram-header">{{i.text}}</div>
                                                <div class="miniprogram-img-thumb"><img class="my-avatar-range"
                                                        :src="i.new_file"></div>
                                                <div class="miniprogram-footer">
                                                    <div class="miniprogram-icon"> <img src="@/assets/img/link.png" />
                                                    </div>
                                                    <div>小程序</div>
                                                </div>
                                            </div>
                                            <div v-else class="message-info" v-html="i.text.replace(/\n/gm, '<br>')">
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </template>
                <div v-else class="nextPage">没有记录</div>
            </div>
        </div>
    </div>
</template>
<script>
import { wechatlist } from '@/utils/config';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue'
import {
    timestampToTime
} from '@/utils/common.js';
const ruleForm = {
    times: [],
    keywords: "",
    types: []
}
export default {
    name: 'wechat',
    components: { BaiduMap, BmMarker, BmLabel },
    data() {
        let windowheight = window.innerHeight;
        return {
            ruleForm: Object.assign({}, ruleForm),
            dialogVisible: false,
            fullscree: true,
            windowheight: windowheight,
            center: { lng: 0, lat: 0 },
            zoom: 3,
            typeList: [{
                id: 3,
                title: '语音消息'
            },
            {
                id: 6,
                title: '语音通话'
            },
            {
                id: 7,
                title: '视频通话'
            },
            {
                id: 9,
                title: '文件'
            },
            {
                id: 18,
                title: '小程序名片'
            },
            {
                id: 10,
                title: '链接'
            }],
            getMemberWechatLog: [],
            type: "",
            page: 1,
            friendId: "",
            staffId: "",
            isShow: false,
            friends: {}

        };
    },
    computed: {
        // 公司列表
        wechatlist() {
            return wechatlist;
        },
    },
    beforeCreate() {
        this.timestampToTime = timestampToTime;

    },
    created() {

    },
    methods: {
        handleSearch() {
            let _this = this;
            _this.page = 1;
            _this.getMemberWechatLog = []
            _this.getTableData()
        },
        showWechat(friend_id, wx_id, type) {
            let _this = this;
            _this.type = type;
            _this.friendId = friend_id;
            _this.staffId = wx_id;
            _this.getMemberWechatLog = []
            _this.page = 1;
            _this.$nextTick(() => {
                _this.getTableData()
            })
            // Your newly generated code
            setTimeout(function () {
                _this.scrollDown()
            }, 1000);


        },
        showUersWechat(wx_id, friend, type) {
            let _this = this;
            _this.type = type;

            _this.staffId = wx_id;
            _this.getMemberWechatLog = []
            _this.page = 1;

            if (friend) {
                _this.friendId = friend.wechat_id;
                _this.friends = friend;
                _this.$nextTick(() => {
                    _this.getTableData();
                })
            }
            // Your newly generated code
            setTimeout(function () {
                _this.scrollDown()
            }, 1000);


        },
        scrollDown() {
            let _this = this;
            let scrollTop = _this.$refs.mianscroll.scrollHeight;
            _this.$refs.mianscroll.scrollTo({ top: scrollTop, behavior: 'smooth' });
        },
        scrolltop() {
            let _this = this;
            let scrollTop = _this.$refs.mianscroll.scrollHeight;
            _this.$refs.mianscroll.scrollTo({ top: scrollTop, behavior: 'smooth' });
        },
        nextPage() {
            let _this = this;
            _this.page++
            _this.getTableData();
        },
        getTableData() {
            //获取表格列表
            let _this = this;
            _this.isShow = true;
            let url = '/api/customer.member/getMemberWechatLog';
            let params = {
                ...this.ruleForm,
                friend_id: _this.friendId,
                wx_id: _this.staffId,
                page: _this.page,
                limit: 20,
            };
            _this.loading = true;
            _this.$post(url, params).then(function (res) {
                if (res.code == 200) {
                    let data = res.data.data;
                    if (data.length > 0) {
                        _this.loading = false;
                        _this.getMemberWechatLog = data.concat(_this.getMemberWechatLog)
                    } else {
                        _this.isShow = false
                        // _this.$message({
                        //     type: 'success',
                        //     message: '已是最后一页哦',
                        //     showClose: true
                        // });
                    }

                }
            });

        }
    }
};
</script>
<style lang="less" scoped>
.wechat-container {
    width: 100%;
    height: 100vh;
    overflow: auto;
    display: flex;
    background-color: #f3f3f3;
}
.map {
    width: 300px;
    height: 300px;
}
.wechat-wrapper {
    flex: 1;
    overflow: hidden;
}
.wechat-top {
    padding: 20px 30px;
    height: 120px;
    border-bottom: solid 1px #e8e8e8;
    width: 100%;
    .wechat-title {
        font-size: 18px;
        font-weight: 500;
        color: #1a1a1a;
        margin-bottom: 10px;
    }
    .input-place {
        width: 200px;
    }
}
.wechat-contant {
    flex: 1;
    position: relative;
    padding: 20px;
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 120px);
    .time-line {
        text-align: center;
        font-size: 12px;
        color: #1a1a1ab3;
    }
    .message-item {
        display: flex;
        flex-direction: row;
        max-width: 100%;
        padding: 10px 0;
        position: relative;
        .my-avatar {
            width: 44px;
            margin-right: 10px;
        }
        .my-avatar-range {
            width: 44px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            border-radius: 8px;
        }
        .my-content {
            .title {
                font-size: 12px;
                padding-bottom: 5px;
            }
            .message-content {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                .message-info {
                    display: inline-block;
                    text-align: left;
                    padding: 10px;
                    background: #ffffff;
                    border-radius: 3px;
                    position: relative;
                    word-break: break-all;
                    &:after {
                        border: 5px solid transparent;
                        border-right-color: #fff;
                        width: 0;
                        height: 0;
                        position: absolute;
                        content: ' ';
                        left: -10px;
                        top: 10px;
                    }
                }
                .message-info-pic {
                    box-sizing: border-box;
                    margin: 0;
                    padding: 0;
                    color: #000000d9;
                    font-size: 14px;
                    font-variant: tabular-nums;
                    line-height: 1.5715;
                    list-style: none;
                    font-feature-settings: 'tnum';
                    position: relative;
                    display: inline-block;
                    line-height: 1;
                    .message-pic {
                        display: block;
                        width: 100%;
                        height: auto;
                        max-width: 300px;
                        display: inline-block;
                        justify-content: flex-start;
                        width: 53px;
                    }
                }
                .message-info-audio {
                    background: white;
                }
                .download-box {
                    display: flex;
                    .download-name {
                        flex: 1;
                        line-height: 50px;
                    }
                    .download-icon {
                        width: 50px;
                        font-size: 25px;
                        margin-left: 10px;
                        line-height: 50px;
                        color: chocolate;
                        .el-icon-download {
                            color: #409eff;
                            cursor: pointer;
                        }
                    }
                }
                .chat-card {
                    width: 240px;
                }
                .chat-card-list {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    border-bottom: 1px solid rgba(26, 26, 26, 0.05);
                    padding: 0 0 10px;
                    .chat-img {
                        width: 44px;
                        height: 44px;
                        overflow: hidden;
                        border-radius: 3px;
                        margin-right: 10px;
                    }
                    .chat-text {
                        flex: 1;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
                .card {
                    padding: 10px 0 0;
                    font-size: 12px;
                }
                .link-box {
                    display: flex;
                    flex-direction: row;
                    position: relative;
                    align-items: center;
                    text-align: left;
                    cursor: pointer;
                    width: 300px;
                    .link-text {
                        flex: 1;
                        font-size: 14px;
                        padding-right: 10px;
                        color: #606266;
                    }
                    .link-img {
                        width: 44px;
                        img {
                            width: 44px;
                            height: 50px;
                        }
                    }
                }
                .miniprogram-header {
                    color: #1a1a1a;
                    text-align: left;
                    font-size: 14px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .miniprogram-img-thumb {
                    max-width: 200px;
                    padding: 10px 0;
                    border-bottom: 1px solid rgba(26, 26, 26, 0.05);
                    .my-avatar-range {
                        max-width: 100% !important;
                    }
                }
                .miniprogram-footer {
                    display: flex;
                    color: #1a1a1a;
                    flex-direction: row;
                    align-items: center;
                    padding: 8px 0 0;
                    font-size: 14px;
                    .miniprogram-icon {
                        margin-right: 8px;
                        img {
                            width: 20px;
                            height: 20px;
                            display: block;
                            overflow: hidden;
                        }
                    }
                }
                .my-avatar-range {
                    width: 300px;
                    display: inline-block;
                    justify-content: flex-start;
                    width: 100%;
                    height: auto;
                }
                .map-title {
                    font-size: 14px;
                    padding: 12px 0;
                }
            }
        }
    }
    .right-message-item {
        flex-direction: row-reverse;
        text-align: right;
        .my-avatar {
            margin-right: 0;
        }
        .my-content {
            margin-right: 10px;
            .message-content {
                justify-content: flex-end;
                .message-info {
                    position: relative;
                    background-color: #217af966;
                    &:after {
                        border: 5px solid transparent;
                        border-left-color: #217af966;
                        width: 0;
                        height: 0;
                        position: absolute;
                        content: ' ';
                        right: -10px;
                        left: auto;
                        top: 10px;
                    }
                }
            }
        }
    }
    .tipsmsg {
        max-width: 100%;
        padding: 10px 0;
        position: relative;
        font-size: 12px;
        text-align: center;
        width: 100%;
        color: #b2b2b2;
    }
    .nextPage {
        max-width: 100%;
        padding: 10px 0;
        position: relative;
        font-size: 12px;
        text-align: center;
        width: 100%;
        color: #000000d9;
        cursor: pointer;
    }
}
</style>